import React from 'react';
import { Ruler, Weight, CheckCircle2, ArrowRight, Wrench } from 'lucide-react';
export function EysProduct() {
  return <section className="w-full bg-slate-50 border-y border-slate-200" data-id="element-94">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16" data-id="element-95">
        <div className="mb-10 max-w-3xl" data-id="element-96">
          <div className="inline-flex items-center gap-2 text-marine-blue text-xs font-semibold uppercase tracking-wider mb-3" data-id="element-97">
            The Original
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-marine-navy mb-3" data-id="element-98">
            Why Boaters Need Extend Your Step
          </h2>
          <p className="text-slate-700 leading-relaxed mb-3" data-id="element-99">
            Many standard boat boarding ladders are simply too short — and that
            causes a lot of frustrating situations.
          </p>
          <p className="text-slate-700 leading-relaxed mb-3" data-id="element-100">
            Have you ever found it difficult to get on your boat with its stock
            ladder? It may be too short, or perhaps you have mobility concerns.
            As you get older, climbing up and down your ladder can become harder
            than it used to be.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start" data-id="element-101">
          {/* Specs */}
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-102">
            <h3 className="text-xl font-bold text-marine-navy mb-5" data-id="element-103">
              Extend Your Step — Specs
            </h3>

            <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-104">
              <div className="bg-marine-light/50 rounded-lg p-4" data-id="element-105">
                <div className="flex items-center gap-2 text-marine-blue text-xs font-semibold uppercase tracking-wider mb-1" data-id="element-106">
                  <Ruler className="w-4 h-4" data-id="element-107" />
                  Dimensions
                </div>
                <div className="text-marine-navy font-bold text-lg" data-id="element-108">
                  10" × 24"
                </div>
                <div className="text-xs text-slate-600" data-id="element-109">Wide × Long</div>
              </div>
              <div className="bg-marine-light/50 rounded-lg p-4" data-id="element-110">
                <div className="flex items-center gap-2 text-marine-blue text-xs font-semibold uppercase tracking-wider mb-1" data-id="element-111">
                  <Weight className="w-4 h-4" data-id="element-112" />
                  Weight Limit
                </div>
                <div className="text-marine-navy font-bold text-lg" data-id="element-113">
                  230 lbs
                </div>
                <div className="text-xs text-slate-600" data-id="element-114">Recommended max</div>
              </div>
            </div>

            <h4 className="text-sm font-semibold text-marine-navy uppercase tracking-wider mb-3" data-id="element-115">
              Compatibility
            </h4>
            <ul className="space-y-2.5 mb-5" data-id="element-116">
              <li className="flex items-start gap-2.5" data-id="element-117">
                <CheckCircle2 className="w-5 h-5 text-marine-cyan flex-shrink-0 mt-0.5" data-id="element-118" />
                <span className="text-sm text-slate-700" data-id="element-119">
                  Fits any tubular boarding ladder and flat steps up to{' '}
                  <strong data-id="element-120">1"</strong>, flat or round.
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-121">
                <CheckCircle2 className="w-5 h-5 text-marine-cyan flex-shrink-0 mt-0.5" data-id="element-122" />
                <span className="text-sm text-slate-700" data-id="element-123">
                  Fits most boarding ladders with rung sizes up to{' '}
                  <strong data-id="element-124">1"</strong> from{' '}
                  <strong data-id="element-125">Garelick, AFI, Windline, Seachoice</strong>, and all
                  round rung ladders.
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-126">
                <CheckCircle2 className="w-5 h-5 text-marine-cyan flex-shrink-0 mt-0.5" data-id="element-127" />
                <span className="text-sm text-slate-700" data-id="element-128">
                  Made from premium high-density polyethylene — far superior to
                  rope ladders for durability, sturdiness, and convenience.
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-129">
                <CheckCircle2 className="w-5 h-5 text-marine-cyan flex-shrink-0 mt-0.5" data-id="element-130" />
                <span className="text-sm text-slate-700" data-id="element-131">
                  Plenty of room for both feet on one step — easily trimmed to
                  size with a hacksaw and Phillips screwdriver if needed.
                </span>
              </li>
            </ul>

            <a href="https://www.clrmarine.com/m4/0CLR_1--extend‑your‑marine‑boarding‑ladder‑clr1.html" className="inline-flex items-center justify-center gap-2 w-full bg-marine-blue hover:bg-marine-navy text-white font-semibold px-5 py-3 rounded-lg transition-colors duration-200" data-id="element-132">
              Purchase Extend Your Step
              <ArrowRight className="w-4 h-4" data-id="element-133" />
            </a>
          </div>

          {/* Measure callout + secondary links */}
          <div className="space-y-5" data-id="element-134">
            <div className="bg-marine-navy text-white rounded-xl p-6 shadow-sm" data-id="element-135">
              <div className="flex items-start gap-3 mb-3" data-id="element-136">
                <div className="bg-marine-cyan/20 text-marine-cyan p-2 rounded-md" data-id="element-137">
                  <Ruler className="w-5 h-5" data-id="element-138" />
                </div>
                <div data-id="element-139">
                  <h3 className="text-lg font-bold mb-1" data-id="element-140">
                    Please Measure Your Ladder Rung Width Before Ordering
                  </h3>
                  <p className="text-sm text-slate-300" data-id="element-141">
                    Then measure again — it makes all the difference. Use the
                    assembly directions for guidance.
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4" data-id="element-142">
                <a href="https://www.clrmarine.com/530.html" className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white text-sm font-medium px-4 py-2.5 rounded-md border border-white/20 transition-colors" data-id="element-143">
                  <Wrench className="w-4 h-4" data-id="element-144" />
                  Assembly Directions
                </a>
                <a href="https://www.clrmarine.com/594.html" className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white text-sm font-medium px-4 py-2.5 rounded-md border border-white/20 transition-colors" data-id="element-145">
                  How to Use It
                </a>
              </div>
            </div>

            <div className="bg-white rounded-xl border border-slate-200 p-6" data-id="element-146">
              <h4 className="text-sm font-semibold text-marine-navy uppercase tracking-wider mb-2" data-id="element-147">
                A Note on Weight
              </h4>
              <p className="text-sm text-slate-700 leading-relaxed" data-id="element-148">
                The recommended weight limit should not exceed{' '}
                <strong data-id="element-149">230 pounds</strong> — but remember, you weigh less in
                the water where you will be using it.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}